"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CounterPillDemo = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Button_1 = require("../Common/Button");
var CounterPill_1 = require("./CounterPill");
var ButtonPillContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: inline-block;\n\tposition: relative;\n"], ["\n\tdisplay: inline-block;\n\tposition: relative;\n"])));
var CounterPillDemo = /** @class */ (function (_super) {
    __extends(CounterPillDemo, _super);
    function CounterPillDemo(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { interactiveCount: 0 };
        _this.incrementCount = _this.incrementCount.bind(_this);
        _this.decrementCount = _this.decrementCount.bind(_this);
        return _this;
    }
    CounterPillDemo.prototype.incrementCount = function () {
        var interactiveCount = this.state.interactiveCount === 5 ? 5 : this.state.interactiveCount + 1;
        this.setState({ interactiveCount: interactiveCount });
    };
    CounterPillDemo.prototype.decrementCount = function () {
        var interactiveCount = this.state.interactiveCount === 0 ? 0 : this.state.interactiveCount - 1;
        this.setState({ interactiveCount: interactiveCount });
    };
    CounterPillDemo.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("h5", null, "Large (default)"),
            React.createElement(CounterPill_1.CounterPill, { size: 'lg', actualCount: 1 }),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null, "<CounterPill size='lg' actualCount={1}/>")),
            React.createElement("h5", null, "Small"),
            React.createElement(CounterPill_1.CounterPill, { size: 'sm', actualCount: 1 }),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null, "<CounterPill size='sm' actualCount={1}/>")),
            React.createElement("h5", null, "Checked"),
            React.createElement(CounterPill_1.CounterPill, { actualCount: 4, expectedCount: 4, checkThreshold: true }),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null, "<CounterPill actualCount={4} expectedCount={4} checkThreshold={true}/>")),
            React.createElement("h5", null, "Warning"),
            React.createElement(CounterPill_1.CounterPill, { actualCount: 1, expectedCount: 4, checkThreshold: true }),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null, "<CounterPill actualCount={1} expectedCount={4} checkThreshold={true}/>")),
            React.createElement("h5", null, "With a button"),
            React.createElement(ButtonPillContainer, null,
                React.createElement(Button_1.Button, null, "Tertiary Button"),
                React.createElement(CounterPill_1.CounterPill, { size: 'sm', actualCount: 100, attached: true })),
            React.createElement("p", { className: 'demo' }, "Example Code"),
            React.createElement("pre", null,
                React.createElement("code", null,
                    "<Button>Tertiary Button</Button> <CounterPill size='sm' actualCount={100} attached={true}/>",
                    React.createElement("br", null),
                    React.createElement("br", null),
                    "Note: In order for Counter Pill to be used with a button, a container is required to be displayed as inline and positioned relatively. Only small size counter pill should be used.")),
            React.createElement("h5", null, "Interactive"),
            React.createElement(CounterPill_1.CounterPill, { size: 'lg', actualCount: this.state.interactiveCount, expectedCount: 5, checkThreshold: true }),
            React.createElement("div", { style: { display: 'block', marginTop: '5px' } },
                React.createElement(Button_1.Button, { onClick: this.decrementCount, size: 'sm' },
                    ' ',
                    "-",
                    ' '),
                ' ',
                "\u00A0",
                React.createElement(Button_1.Button, { onClick: this.incrementCount, size: 'sm' },
                    ' ',
                    "+",
                    ' '))));
    };
    return CounterPillDemo;
}(React.Component));
exports.CounterPillDemo = CounterPillDemo;
var templateObject_1;
